import React from 'react';
import { Link } from 'react-router-dom';
import Lottie from 'react-lottie';
import Image404 from '../assets/images/404.json';
import MetaDecorators from '../components/MetaDecorators';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: Image404,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

function NotFound() {
  return (
    <div className='wrapper pageNotFoundContainer'>
      <MetaDecorators />
      <div>
        <h1>We could not find what you are looking for 😔</h1>
        <h3>You can try looking into the following place:</h3>
        <Link to='/'>Home</Link>
      </div>
      <div className='Image404Box'>
        <Lottie options={defaultOptions} width={'100%'} isClickToPauseDisabled={true} />
      </div>
    </div>
  );
}

export default NotFound;
